<template>
  <nudge-message
    v-if="!hasBeenDismissed"
    :icon-name="iconName"
    :icon-style="iconStyle"
    :icon-rotation="iconRotation"
    :title="title"
    :content="content"
    :aria-label-close="ariaLabelClose"
    :pointer-orientation-y="pointerOrientationY"
    :pointer-orientation-x="pointerOrientationX"
    :pointer-position-x="pointerPositionX"
    @dismiss-nudge="dismissNudge"
  >
  </nudge-message>
</template>

<script>
  import { merge } from 'lodash'
  import NudgeMessage from './NudgeMessage'
  import { EventTrackingMixin } from 'app/mixins'

  const hasBeenDismissedKey = function (nudgeName) {
    return `Nudge Dismissed - ${nudgeName}`
  }

  export default {
    name: 'Nudge',

    components: {
      NudgeMessage
    },

    mixins: [EventTrackingMixin],

    props: {
      ariaLabelClose: {
        type: String,
        default: 'Close'
      },
      content: {
        type: String,
        default: null
      },
      iconName: {
        type: String,
        default: null
      },
      iconRotation: {
        type: String,
        default: null
      },
      iconStyle: {
        type: String,
        default: 'solid'
      },
      title: {
        type: String,
        default: null
      },
      nudgeName: {
        type: String,
        default: null,
        required: true
      },
      pointerOrientationX: {
        type: String,
        default: 'left'
      },
      pointerOrientationY: {
        type: String,
        default: 'top'
      },
      pointerPositionX: {
        type: String,
        default: '-0.5rem'
      }
    },

    data() {
      const hasBeenDismissed = localStorage.getItem(hasBeenDismissedKey(this.nudgeName))

      return {
        hasBeenDismissed: hasBeenDismissed ? true : false
      }
    },

    created() {
      if (!this.hasBeenDismissed) {
        this.$posthog.capture('nudge_view', merge({ context: `${this.nameSlug(this.nudgeName)}` }, this.determinationsEventProps))
      }
    },

    methods: {
      dismissNudge() {
        localStorage.setItem(hasBeenDismissedKey(this.nudgeName), 1)
        this.$posthog.capture('nudge_cancel', merge({ context: `${this.nameSlug(this.nudgeName)}` }, this.determinationsEventProps))
        this.hasBeenDismissed = true
      }
    }
  }
</script>
